module.exports = __webpack_public_path__ + "static/img/dy.07db89d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dy.png
// module id = c0Ke
// module chunks = 1